import { useAuth } from "@/auth/useAuth";

/** Право редактирования раздела «Заказы»: админ или страница-право orders_edit. */
export function useOrdersEdit(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.is_admin || user.permissions.includes("orders_edit");
}
